export default __webpack_public_path__ + "static/media/button-mini-add.bde16ab3.svg";